{
  "name": "feelbetr-front",
  "version": "1.7.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve -c local --port 4051 --host 0.0.0.0",
    "build": "ng build",
    "build:dev": "ng build -c development",
    "build:staging": "ng build -c staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.0",
    "@angular/cdk": "~22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/material": "~22.2.0",
    "@angular/material-date-fns-adapter": "~22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@ngrx/eslint-plugin": "^22.0.1",
    "@ngrx/operators": "^22.0.1",
    "@ngrx/signals": "^22.0.1",
    "@wlcm/angular": "^22.2.1",
    "@wlcm/common": "^1.0.2",
    "date-fns": "^4.1.0",
    "echarts": "^6.1.0",
    "hls.js": "^1.7.3",
    "ng-inline-svg-2": "^20.0.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.5.0",
    "@angular-eslint/eslint-plugin": "22.5.0",
    "@angular-eslint/eslint-plugin-template": "22.5.0",
    "@angular-eslint/schematics": "22.5.0",
    "@angular-eslint/template-parser": "22.5.0",
    "@angular/build": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@eslint/js": "^10.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.12.0",
    "angular-eslint": "22.5.0",
    "eslint": "^10.11.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "globals": "^17.12.0",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.4.3",
    "prettier": "^3.4.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.70.1"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "prettier --write",
      "eslint --fix",
      "git add"
    ]
  }
}
